module.exports = __webpack_public_path__ + "static/media/Speed_start.be2ae61a.mp4";